/**
 * @generated SignedSource<<5c094ca8ce65bdfd2198443088d9f19e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CollectorTileContent_nftItem$data = {
  readonly auction: {
    readonly auctionId: number | null;
    readonly contractAddress: {
      readonly address: string | null;
    } | null;
    readonly status: NftAuctionStatus | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly pdpUrl: string | null;
  readonly serviceId: string | null;
  readonly wasBurned: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftItem" | "NftItemTileItemDetails_nftItem" | "NftItemTileTokenDetails_nftItem" | "NftItemTileTooltip_nftItem" | "useMarketContext_nftItem">;
  readonly " $fragmentType": "CollectorTileContent_nftItem";
};
export type CollectorTileContent_nftItem$key = {
  readonly " $data"?: CollectorTileContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectorTileContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileItemDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileTokenDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileTooltip_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketContext_nftItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasBurned",
      "storageKey": null
    },
    {
      "alias": "auction",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeCanceled",
          "value": true
        }
      ],
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "auctionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "contractAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "mostRecentAuction(excludeCanceled:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "8b89dd4a1f297a0d05f05449a4b80c18";

export default node;
